import React, { useState, useRef, useEffect } from "react";
import july from './assets/July/july.png';
import gif from './assets//Chips/8.png';
import wops from './assets/wops.png';
import pet from './assets/pet.jpg';
import eml from './assets/eml.jpg';
import seguro from './assets/seguro.png';
import door from './assets/door.jpg';
import { Link } from 'react-router-dom';
import './project.css';
import emailjs from '@emailjs/browser';



const MyProjects = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []); //for scroll to the top always I mean whenever the page opens the page will be at the top

    const [notification, setNotification] = useState("");
    const [isOverlayVisible, setOverlayVisible] = useState(false);

    const toggleOverlay = () => {
        setOverlayVisible(!isOverlayVisible);
    };
    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault();

        // Get form data
        const formData = new FormData(form.current);
        const name = formData.get("user_name");
        const email = formData.get("user_email");
        const subject = formData.get("user_subject");
        const message = formData.get("message");

        // Check if any field is empty
        if (!name || !email || !subject || !message) {
            setNotification("All fields are required!");
            setTimeout(() => setNotification(""), 3000); // Hide notification after 3 seconds
            return;
        }

        emailjs
            .sendForm('service_mh1ddkn', 'template_2zi8jcs', form.current, 'dBrGazk0t-K47QR2W')
            .then(
                () => {
                    setNotification("Message sent successfully!");
                    form.current.reset(); // Reset form fields
                    setTimeout(() => setNotification(""), 3000); // Hide notification after 3 seconds
                },
                (error) => {
                    setNotification("Failed to send message. Try again!");
                    setTimeout(() => setNotification(""), 3000); // Hide notification after 3 seconds
                    console.log("FAILED...", error.text);
                }
            );
    };

    // mouse cursor
        const [position, setPosition] = useState({ x: 0, y: 0 });
        const [hovered, setHovered] = useState(false);
    
        useEffect(() => {
            const handleMouseMove = (e) => {
                setPosition({ x: e.clientX, y: e.clientY });
            };
    
            document.addEventListener("mousemove", handleMouseMove);
    
            return () => {
                document.removeEventListener("mousemove", handleMouseMove);
            };
        }, []);
    
        useEffect(() => {
            const clickableElements = document.querySelectorAll("button, a, .logo, svg");
    
            clickableElements.forEach((element) => {
                element.addEventListener("mouseenter", () => setHovered(true));
                element.addEventListener("mouseleave", () => setHovered(false));
            });
    
            return () => {
                clickableElements.forEach((element) => {
                    element.removeEventListener("mouseenter", () => setHovered(true));
                    element.removeEventListener("mouseleave", () => setHovered(false));
                });
            };
        }, []);

    return (
        <div className="project-page">
            <div className={`cursor ${hovered ? "cursor-hover" : ""}`} style={{ left: `${position.x}px`, top: `${position.y}px` }} />
            <div className="navbar" >
                <p onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>pranav.</p>
                <svg onClick={toggleOverlay} width="30" height="25" viewBox="0 0 30 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="30" height="5" rx="2.5" fill="#101010" />
                    <rect y="10" width="30" height="5" rx="2.5" fill="#101010" />
                    <rect y="20" width="30" height="5" rx="2.5" fill="#101010" /></svg>

                <ul className={`overlay ${isOverlayVisible ? "show" : ""}`}>
                    <div className="anim">
                        <div className="dot-anim"></div>
                        <li><Link to="/">home.</Link></li>
                    </div>
                    <div className="anim">
                        <div className="dot-anim"></div>
                        <li><Link to="/allprojects">project.</Link></li>
                    </div>
                    <div className="anim">
                        <div className="dot-anim"></div>
                        <li><Link to="/about">about.</Link></li>
                    </div>
                    <div className="anim">
                        <div className="dot-anim"></div>
                        <li><Link to="/contact">contact.</Link></li>
                    </div>
                    <div className="available">
                        <div className="dot-green"></div>available for freelance.
                    </div>
                </ul>
            </div>

            <div className="hero-container">
                <div className="title">
                    <h1>all projects.</h1>
                    <p>journey through my portfolio, showcasing a blend of refined artistry and bold experimentation that defines my creative vision.</p>
                </div>
            </div>

            <div className="list">

                <div className="box-one">
                    <Link to="/wops">
                        <div className="imgs">
                            <img src={wops} />
                        </div>
                        <div className="p1">
                            <h1>world of perfumers.</h1>
                            <div className="elements">
                                <p>branding.</p>
                                <p>ui/ux.</p>
                                <p>package design.</p>
                            </div>
                        </div>
                    </Link>
                </div>

                <div className="box-one">
                    <Link to="/gif">
                        <div className="imgs">
                            <img src={gif} />
                        </div>
                        <div className="p1">
                            <h1>gif.</h1>
                            <div className="elements">
                                <p>package design.</p>
                                <p>mockups.</p>
                            </div>
                        </div>
                    </Link>
                </div>

                <div className="box-one">
                    <Link to="/july">
                        <div className="imgs">
                            <img src={july} />
                        </div>
                        <div className="p1">
                            <h1>july.</h1>
                            <div className="elements">
                                <p>package design.</p>
                                <p>3d mockups</p>
                            </div>
                        </div>
                    </Link>
                </div>

            </div>

            <div className="boxes">
                <h1>more projects.</h1>

                <div className="box-container">
                    <Link to="/eml" className="box">
                        <div className="image">
                            <img src={eml} />
                        </div>
                        <div className="context">
                            <h2>elizabeth milan london.</h2>
                            <div className="tags">
                                <p>ui redesign.</p>
                            </div>
                        </div>
                    </Link>

                    <Link to="/pet" className="box">
                        <div className="image">
                            <img src={pet} />
                        </div>
                        <div className="context">
                            <h2>petvouge.</h2>
                            <div className="tags">
                                <p>ui/ux design.</p>
                            </div>
                        </div>
                    </Link>
                </div>

                <div className="box-container">

                    <Link to="/seguro" className="box">
                        <div className="image">
                            <img src={seguro} />
                        </div>
                        <div className="context">
                            <h2>seguro.</h2>
                            <div className="tags">
                                <p>3d re-model.</p>
                                <p>texturing.</p>
                            </div>
                        </div>
                    </Link>

                    <Link to="/3d" className="box">
                        <div className="image">
                            <img src={door} />
                        </div>
                        <div className="context">
                            <h2>3d projects.</h2>
                            <div className="tags">
                                <p>3d environment.</p>
                                <p>animations.</p>
                                <p>modeling.</p>
                            </div>
                        </div>
                    </Link>

                </div>


            </div>

            <div className="missed-heading" id="contact">
                <h1>say hi.</h1>
                <div id="getintouch" className="sayhi">
                    <div className="contact-title">
                        <h1>let’s collaborate.</h1><br />
                        <p>have any idea in your mind?</p>
                        <p>fell free to reach out.</p>
                    </div>
                    <form className="contact" ref={form} onSubmit={sendEmail}>
                        <div className="textboxes">
                            <p>name.</p>
                            <input name="user_name" placeholder="John Doe" maxlength="25"></input>
                        </div>
                        <div className="textboxes">
                            <p>email.</p>
                            <input name="user_email" type="email" placeholder="example@gmail.com" maxlength="25"></input>
                        </div>
                        <div className="textboxes">
                            <p>subject.</p>
                            <input name="user_subject" placeholder="project abc" maxlength="25"></input>
                        </div>
                        <div className="textboxes">
                            <p>message.</p>
                            <input name="message" className="message" placeholder="I want your help in..." id=""></input>
                        </div>
                        <button type="submit" className="submit">submit.</button>
                    </form>
                </div>
            </div>

            {/* Popup Notification */}
            {notification && (
                <div className="popup">
                    <p>{notification}</p>
                </div>
            )}

            <footer>
                <p>designed and developed by</p>
                <ul>pranav pradeep.</ul>
            </footer>
        </div>
    )
};
export default MyProjects;